var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.8 21.966-5.916 5.18-6.163 5.178-5.916-5.179",
    stroke: "#10A8BA",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.68 56S2 47.122 2 27.145V6.923a54.71 54.71 0 0 1 45.36 0v20.223C47.36 47.121 24.68 56 24.68 56Z",
    stroke: "#10A8BA",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })));
};
export default SvgShield;